var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelephoneSearch = function SvgTelephoneSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.043 7.719c.63-.63.786-1.591.388-2.387L8.337 3.143A2.07 2.07 0 0 0 5.78 2.125l-2.45.891c-.886.322-1.45 1.206-1.308 2.137 1.437 9.402 7.423 15.388 16.825 16.825.931.142 1.815-.422 2.137-1.307l.891-2.451a2.07 2.07 0 0 0-1.018-2.557l-2.189-1.094a2.07 2.07 0 0 0-2.387.388l-1.53 1.53c-3.103-1.033-6.205-4.135-7.239-7.237z"
  })));
};
export default SvgTelephoneSearch;